import {CategoryItem} from '../CategoryItem/CategoryItem';

export const Categories = ({categories, open, navLevel, navigateToCategory, setNavLevel}) =>
  categories.map((category) => (
    <CategoryItem
      key={category.title || category.display_name}
      category={category}
      title={category.title}
      linkTabIndex={open && navLevel === 0 ? 0 : -1}
      level={0}
      setLevel1Category={navigateToCategory}
      setNavLevel={setNavLevel}
    />
  ));
